import { Col, Row } from 'antd';
import React from 'react';
import css from './centered-section.module.less';

export const CenteredSection = ({ children }) => (
  <Row justify="center" align="middle" className={css.height}>
    <Col>
      {children}
    </Col>
  </Row>
);
